import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import moment from 'moment';
import styles from './styles.css';

@autobind
export default class OrderTable extends Component {
    static propTypes = {
        orders: PropTypes.array,
        onOrderclick: PropTypes.func.isRequired,
        totalOrders: PropTypes.number,
    };

    handleRowClick(id) {
        return () => this.props.onOrderclick(id);
    }

    render() {
        return (
            <table className={styles.table}>
                <caption className={styles.caption}>{
                    this.props.totalOrders > 0 && `${this.props.totalOrders} pedidos seleccionados según tus filtros`}
                </caption>
                <thead>
                    <tr>
                        <th>Pedido</th>
                        <th>Fecha</th>
                        <th>Organización</th>
                        <th>Tipo</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.orders.map(order => (
                        <tr key={order.id} onClick={this.handleRowClick(order.id)}>
                            <td className={styles.id}>
                                <div className={styles.boxIcon} /> #{order.id}
                            </td>
                            <td>{moment(order.created).format('LLL')}</td>
                            <td>{order.organization.name}</td>
                            <td>{order.category.name}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./components/order-table/index.js